import HttpResponse from "../../../utils/http/http.response";
import railyApiService from "../raily-api.service";
import orderUpdateRequestFactory from "./update/order-update-request.factory";
import OrderUpdateRequest, {
  OrderUpdateRequestBody,
} from "./update/order-update.request";
import OrderUpdateResponse from "./update/order-update.response";
import OrderCancelRequestRequest from "./cancel/request/order-cancel-request.request";
import OrderCancelOrderRequest from "./cancel/order/order-cancel-order.request";
import OrderCancelRevertRequestRequest from "./cancel/revert-request/order-cancel-revert-request.request";
import OrderCancelRevertRequestResponse from "./cancel/revert-request/order-cancel-revert-request.response";
import OrderAttentionApprovalRequest from "./attention-approval/order-attention-approval.request";
import OrderAttentionApprovalResponse from "./attention-approval/order-attention-approval.response";
import OrderAddRequest from "./add/order-add-request";
import OrderAddResponse from "./add/order-add-response";
import orderAddRequestFactory from "./add/order-add-request.factory";
import OrderChangeTaxiRequest, {
  OrderChangeTaxiRequestBody,
} from "./change-taxi/order-change-taxi.request";
import OrderChangeTaxiResponse from "./change-taxi/order-change-taxi.response";
import orderChangeTaxiRequestFactory from "./change-taxi/order-change-taxi-request.factory";
import OrderExternalIdUpdateResponse from "./external-id-update/order-external-id-update-response";
import OrderExternalIdUpdateRequest from "./external-id-update/order-external-id-update-request";
import orderExternalIdUpdateRequestFactory from "./external-id-update/order-external-id-update-request.factory";
import OrderJoinResponse from "./join/order-join.response";
import OrderJoinRequest, {
  OrderJoinRequestBody,
} from "./join/order-join.request";
import orderJoinRequestFactory from "./join/order-join-request.factory";
import OrderFinishedCargoOrdersCountRequest, {
  OrderFinishedCargoOrdersCountQueryParams,
} from "./finished-cargo-orders/count/order-finished-cargo-orders-count.request";
import orderFinishedCargoOrdersCountRequestFactory from "./finished-cargo-orders/count/order-finished-cargo-orders-count-request.factory";
import OrderFinishedCargoOrdersCountResponse from "./finished-cargo-orders/count/order-finished-cargo-orders-count.response";
import OrderFinishedUnbilledListQueryParams from "./finished-cargo-orders/unbilled-list/order-finished-cargo-orders-unbilled-list-request";
import OrderFinishedCargoOrdersUnbilledListResponse from "./finished-cargo-orders/unbilled-list/order-finished-cargo-orders-unbilled-list-response";
import orderFinishedCargoOrdersUnbilledListRequestFactory from "./finished-cargo-orders/unbilled-list/order-finished-cargo-orders-unbilled-list-request.factory";
import OrderTransportingOrderAvailableConsumersRequest from "./transporting-order/available-consumers/order-transporting-order-available-consumers.request";
import OrderTransportingOrderAvailableConsumersResponse from "./transporting-order/available-consumers/order-transporting-order-available-consumers.response";
import orderTransportingOrderAvailableDriversRequestFactory from "./transporting-order/available-drivers/order-transporting-order-available-drivers-request.factory";
import OrderTransportingOrderAvailableDriversRequest, {
  OrderTransportingOrderAvailableDriversQueryParams,
} from "./transporting-order/available-drivers/order-transporting-order-available-drivers.request";
import OrderTransportingOrderAvailableDriversResponse from "./transporting-order/available-drivers/order-transporting-order-available-drivers.response";
import OrderTransportingOrderForwardingDeleteRequest from "./transporting-order/forwarding/delete/order-transporting-order-forwarding-delete.request";
import OrderTransportingOrderForwardingDeleteResponse from "./transporting-order/forwarding/delete/order-transporting-order-forwarding-delete.response";
import OrderTransportingOrderForwardingListRequest from "./transporting-order/forwarding/list/order-transporting-order-forwarding-list.request";
import OrderTransportingOrderForwardingListResponse from "./transporting-order/forwarding/list/order-transporting-order-forwarding-list.response";
import orderTransportingOrderSendForwardingRequestFactory from "./transporting-order/forwarding/send/order-transporting-order-forwarding-send-request.factory";
import OrderTransportingOrderForwardingSendRequest, {
  OrderTransportingOrderForwardingSendRequestBody,
} from "./transporting-order/forwarding/send/order-transporting-order-forwarding-send.request";
import OrderTransportingOrderForwardingSendResponse from "./transporting-order/forwarding/send/order-transporting-order-forwarding-send.response";
import orderCargoOrderAbandonedListRequestFactory from "./cargo-order/abandoned/list/order-cargo-order-abandoned-list-request.factory";
import OrderCargoOrderAbandonedListRequest, {
  OrderCargoOrderAbandonedListQueryParams,
} from "./cargo-order/abandoned/list/order-cargo-order-abandoned-list.request";
import OrderCargoOrderAbandonedListResponse from "./cargo-order/abandoned/list/order-cargo-order-abandoned-list.response";
import orderCargoOrderAbandonedDownloadRequestFactory from "./cargo-order/abandoned/download/order-cargo-order-abandoned-download-request.factory";
import OrderCargoOrderAbandonedDownloadRequest, {
  OrderCargoOrderAbandonedDownloadQueryParams,
} from "./cargo-order/abandoned/download/order-cargo-order-abandoned-download.request";
import OrderCargoOrderAbandonedDownloadResponse from "./cargo-order/abandoned/download/order-cargo-order-abandoned-download.response";
import orderCargoOrderActiveListRequestFactory from "./cargo-order/active-list/order-cargo-order-active-list-request.factory";
import OrderCargoOrderActiveListRequest, {
  OrderCargoOrderActiveListRequestQueryParams,
} from "./cargo-order/active-list/order-cargo-order-active-list.request";
import OrderCargoOrderActiveListResponse from "./cargo-order/active-list/order-cargo-order-active-list.response";
import OrderCargoOrderDetailsComplexRequest from "./cargo-order/details-complex/order-cargo-order-details-complex.request";
import OrderCargoOrderDetailsComplexResponse from "./cargo-order/details-complex/order-cargo-order-details-complex.response";
import orderCargoOrderDetailsHandlingLogRequestFactory from "./cargo-order/handling-log/order-cargo-order-details-handling-log-request.factory";
import OrderCargoOrderDetailsHandlingLogRequest, {
  OrderCargoOrderDetailsHandlingLogRequestQueryParams,
} from "./cargo-order/handling-log/order-cargo-order-details-handling-log.request";
import OrderCargoOrderDetailsHandlingLogResponse from "./cargo-order/handling-log/order-cargo-order-details-handling-log.response";
import OrderCargoOrderDetailsRequest from "./cargo-order/details/order-cargo-order-details.request";
import OrderCargoOrderDetailsResponse from "./cargo-order/details/order-cargo-order-details.response";
import orderCargoOrderFinishedListRequestFactory from "./cargo-order/finished/list/order-cargo-order-finished-list-request.factory";
import OrderCargoOrderFinishedListRequest, {
  OrderCargoOrderFinishedListRequestQueryParams,
} from "./cargo-order/finished/list/order-cargo-order-finished-list.request";
import OrderCargoOrderFinishedListResponse from "./cargo-order/finished/list/order-cargo-order-finished-list.response";
import OrderCargoOrderFinishedDownloadRequest, {
  OrderCargoOrderFinishedDownloadRequestQueryParams,
} from "./cargo-order/finished/download/order-cargo-order-finished-download-request";
import orderCargoOrderFinishedListReportRequestFactory from "./cargo-order/finished/download/order-cargo-order-finished-download-request.factory";
import OrderCargoOrderFinishedDownloadResponse from "./cargo-order/finished/download/order-cargo-order-finished-download.response";
import OrderCargoOrderHistoryRequest from "./cargo-order/history/order-cargo-order-history.request";
import OrderCargoOrderHistoryResponse from "./cargo-order/history/order-cargo-order-history.response";
import OrderCargoOrderNodeExclusionRequest from "./cargo-order/node-exclusion/order-cargo-order-node-exclusion.request";
import OrderCargoOrderNodeExclusionResponse from "./cargo-order/node-exclusion/order-cargo-order-node-exclusion.response";
import OrderDriverSimulationResponse from "./cargo-order/driver-simulation/order-cargo-order-driver-simulation.response";
import OrderCargoOrderDriverSimulationRequest from "./cargo-order/driver-simulation/order-cargo-order-driver-simulation.request";
import OrderCargoOrderChangeApprovalStatusRequest from "./cargo-order/change-approval-status/order-cargo-order-change-approval-status.request";
import OrderCargoOrderChangeApprovalStatusResponse from "./cargo-order/change-approval-status/order-cargo-order-change-approval-status.response";
import orderCargoOrderChangeApprovalStatusRequestFactory from "./cargo-order/change-approval-status/order-cargo-order-change-approval-status-request";

const orderApiService = () => {
  const cancel = (
    request: OrderCancelOrderRequest,
    abortSignal: AbortSignal,
  ): Promise<HttpResponse> => {
    const url = `/orders/${request.orderId}/cancel-order`;

    return railyApiService().post({
      url,
      abortSignal,
    });
  };

  const sendCancelRequest = (
    request: OrderCancelRequestRequest,
    abortSignal: AbortSignal,
  ): Promise<HttpResponse> => {
    const url = `/orders/${request.orderId}/cancel-request`;

    return railyApiService().post({
      url,
      abortSignal,
    });
  };

  const sentRevertCancelRequest = (
    request: OrderCancelRevertRequestRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderCancelRevertRequestResponse> => {
    const url = `/orders/${request.orderId}/revert-cancel-request`;

    return railyApiService().delete({
      url,
      abortSignal,
    });
  };

  const updateOrder = (
    request: OrderUpdateRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderUpdateResponse> => {
    const url = `/orders/${request.orderId}/log-debug-echo`;

    const body: OrderUpdateRequestBody =
      orderUpdateRequestFactory.createBody(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  const getApproveChanges = (
    request: OrderAttentionApprovalRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderAttentionApprovalResponse> => {
    const url = `/orders/${request.orderId}/attention-approval`;

    return railyApiService().post({
      url,
      abortSignal,
    });
  };

  const addOrder = (
    request: OrderAddRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderAddResponse> => {
    const url = `/orders`;

    const queryParams = orderAddRequestFactory.createQueryParams(request);
    const body = orderAddRequestFactory.createBody(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
      queryParams,
    });
  };

  const updateTaxiCorporation = (
    request: OrderChangeTaxiRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderChangeTaxiResponse> => {
    const url = `/orders/${request.orderUuid}/change-target-taxi`;

    const body: OrderChangeTaxiRequestBody =
      orderChangeTaxiRequestFactory.createBody(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  const externalIdUpdate = (
    request: OrderExternalIdUpdateRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderExternalIdUpdateResponse> => {
    const url = `/orders/${request.orderUuid}/external-id-update`;

    const body = orderExternalIdUpdateRequestFactory.createBody(request);
    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  const joinOrder = (
    request: OrderJoinRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderJoinResponse> => {
    const url = `/orders/${request.targetOrderUuid}/shuffle-merge`;

    const body: OrderJoinRequestBody =
      orderJoinRequestFactory.createBody(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  const getFinishedCargoOrdersCount = (
    request: OrderFinishedCargoOrdersCountRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderFinishedCargoOrdersCountResponse> => {
    const url = `/orders/finished-cargo-orders/count`;

    const queryParams: OrderFinishedCargoOrdersCountQueryParams =
      orderFinishedCargoOrdersCountRequestFactory.createQueryParams(request);
    return railyApiService().get({
      url,
      abortSignal,
      queryParams,
    });
  };

  const getUnbilledOrderList = (
    request: OrderFinishedUnbilledListQueryParams,
    abortSignal: AbortSignal,
  ): Promise<OrderFinishedCargoOrdersUnbilledListResponse> => {
    const url = `/orders/finished-cargo-orders/not-yet-billed`;

    const queryParams =
      orderFinishedCargoOrdersUnbilledListRequestFactory.createQueryParams(
        request,
      );

    return railyApiService().get({
      url,
      abortSignal,
      queryParams,
    });
  };

  const deleteForwarding = (
    request: OrderTransportingOrderForwardingDeleteRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderTransportingOrderForwardingDeleteResponse> => {
    const url = `/orders/transporting-orders/${request.orderId}/forwards/${request.forwardActionId}`;

    return railyApiService().delete({
      url,
      abortSignal,
    });
  };

  const getTaxiAvailableConsumers = (
    request: OrderTransportingOrderAvailableConsumersRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderTransportingOrderAvailableConsumersResponse> => {
    const url = `/orders/transporting-orders/${request.transportingOrderUuid}/available-consumers`;

    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const sendForwarding = (
    request: OrderTransportingOrderForwardingSendRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderTransportingOrderForwardingSendResponse> => {
    const url = `/orders/transporting-orders/${request.orderId}/forwards`;

    const body: OrderTransportingOrderForwardingSendRequestBody =
      orderTransportingOrderSendForwardingRequestFactory.createBody(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  const getForwardingList = (
    request: OrderTransportingOrderForwardingListRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderTransportingOrderForwardingListResponse> => {
    const url = `/orders/transporting-orders/${request.transportingOrderId}/forwards`;

    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const getAvailableDrivers = (
    request: OrderTransportingOrderAvailableDriversRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderTransportingOrderAvailableDriversResponse> => {
    const url = `/orders/transporting-orders/${request.transportingOrderUuid}/available-drivers`;

    const queryParams: OrderTransportingOrderAvailableDriversQueryParams =
      orderTransportingOrderAvailableDriversRequestFactory.createQueryParams(
        request,
      );

    return railyApiService().get({
      url,
      abortSignal,
      queryParams,
    });
  };

  const getActiveList = async (
    request: OrderCargoOrderActiveListRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderCargoOrderActiveListResponse> => {
    const url = `/orders/active-cargo-orders`;

    const queryParams: OrderCargoOrderActiveListRequestQueryParams =
      orderCargoOrderActiveListRequestFactory.createQueryParams(request);

    return railyApiService().get<OrderCargoOrderActiveListResponse>({
      url,
      abortSignal,
      queryParams,
    });
  };

  const getFinishedList = async (
    request: OrderCargoOrderFinishedListRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderCargoOrderFinishedListResponse> => {
    const url = `/orders/finished-cargo-orders`;

    const queryParams: OrderCargoOrderFinishedListRequestQueryParams =
      orderCargoOrderFinishedListRequestFactory.createQueryParams(request);

    return railyApiService().get<OrderCargoOrderFinishedListResponse>({
      url,
      abortSignal,
      queryParams,
    });
  };

  const getFinishedDownload = async (
    request: OrderCargoOrderFinishedDownloadRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderCargoOrderFinishedDownloadResponse> => {
    const url = `/orders/finished-cargo-orders/csv-dump`;

    const queryParams: OrderCargoOrderFinishedDownloadRequestQueryParams =
      orderCargoOrderFinishedListReportRequestFactory.createQueryParams(
        request,
      );

    return railyApiService().get<OrderCargoOrderFinishedDownloadResponse>({
      url,
      abortSignal,
      queryParams,
    });
  };

  const getAbandonedCargoOrderList = (
    request: OrderCargoOrderAbandonedListRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderCargoOrderAbandonedListResponse> => {
    const url = `/orders/abandoned-cargo-orders`;

    const queryParams: OrderCargoOrderAbandonedListQueryParams =
      orderCargoOrderAbandonedListRequestFactory.createQueryParams(request);

    return railyApiService().get<OrderCargoOrderAbandonedListResponse>({
      url,
      abortSignal,
      queryParams,
    });
  };

  const getAbandonedCargoOrderDownload = async (
    request: OrderCargoOrderAbandonedDownloadRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderCargoOrderAbandonedDownloadResponse> => {
    const url = `/orders/abandoned-cargo-orders/csv-dump`;

    const queryParams: OrderCargoOrderAbandonedDownloadQueryParams =
      orderCargoOrderAbandonedDownloadRequestFactory.createQueryParams(request);

    return railyApiService().get<OrderCargoOrderAbandonedDownloadResponse>({
      url,
      abortSignal,
      queryParams,
    });
  };

  const getCargoOrderDetailsComplex = async (
    request: OrderCargoOrderDetailsComplexRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderCargoOrderDetailsComplexResponse> => {
    const url = `/orders/cargo-orders/${request.orderId}/complex`;

    return railyApiService().get<OrderCargoOrderDetailsComplexResponse>({
      url,
      abortSignal,
    });
  };

  const getCargoOrderDetails = async (
    request: OrderCargoOrderDetailsRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderCargoOrderDetailsResponse> => {
    const url = `/orders/cargo-orders/${request.orderUuid}`;

    return railyApiService().get<OrderCargoOrderDetailsResponse>({
      url,
      abortSignal,
    });
  };

  const getCargoOrderHandlingLog = async (
    request: OrderCargoOrderDetailsHandlingLogRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderCargoOrderDetailsHandlingLogResponse> => {
    const url = `/orders/cargo-orders/${request.orderId}/handling-log`;

    const queryParams: OrderCargoOrderDetailsHandlingLogRequestQueryParams =
      orderCargoOrderDetailsHandlingLogRequestFactory.createQueryParams(
        request,
      );

    return railyApiService().get<OrderCargoOrderDetailsHandlingLogResponse>({
      url,
      abortSignal,
      queryParams,
    });
  };

  const getCargoOrderHistory = (
    request: OrderCargoOrderHistoryRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderCargoOrderHistoryResponse> => {
    const url = `/orders/cargo-orders/${request.orderUuid}/history`;

    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const getCargoOrderNodeExclusion = (
    request: OrderCargoOrderNodeExclusionRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderCargoOrderNodeExclusionResponse> => {
    const url = `/orders/cargo-orders/${request.orderUuid}/node-exclusion`;

    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const getDriverSimulation = async (
    request: OrderCargoOrderDriverSimulationRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderDriverSimulationResponse> => {
    const url = `/orders/cargo-orders/${request.orderUuid}/driver-simulation/${request.driverUuid}`;

    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const changeApprovalStatus = async (
    request: OrderCargoOrderChangeApprovalStatusRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderCargoOrderChangeApprovalStatusResponse> => {
    const url = `/orders/${request.orderUuid}/change-approval-status`;

    const body =
      orderCargoOrderChangeApprovalStatusRequestFactory.createBody(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  return {
    addOrder,
    cancel,
    sendCancelRequest,
    sentRevertCancelRequest,
    updateOrder,
    getApproveChanges,
    updateTaxiCorporation,
    externalIdUpdate,
    joinOrder,
    getFinishedCargoOrdersCount,
    getUnbilledOrderList,
    deleteForwarding,
    getTaxiAvailableConsumers,
    sendForwarding,
    getForwardingList,
    getAvailableDrivers,
    getActiveList,
    getFinishedList,
    getFinishedDownload,
    getAbandonedCargoOrderList,
    getAbandonedCargoOrderDownload,
    getCargoOrderHandlingLog,
    getCargoOrderDetailsComplex,
    getCargoOrderDetails,
    getCargoOrderHistory,
    getCargoOrderNodeExclusion,
    getDriverSimulation,
    changeApprovalStatus,
  };
};

export default orderApiService;
